<div *ngIf="quote" class="container-fluid">
  <div>
    <label class="text-bidit-primary-header ml-3 mt-3"><span i18n>Quote Template</span>: {{quote.quote_Name}}</label>
    <a class="btn btn-bidit-edit-dark mr-2" (click)="editTemplate()"> </a>
  </div>
  <app-quote-details [id]="quoteId" (toggleTemplate)="templateList($event)" (updated)="quoteUpdated($event)"></app-quote-details>
</div>
